import { User as CoreUser } from '@grammarly/http-clients-auth'
import { serializeKey, deserializeValue, AuthCustomFieldsKey } from '@grammarly/auth-custom-fields-client'

const noneUserData = {} as CoreUser

export class User {
  public static None: User = new User(noneUserData)

  public static create(data?: CoreUser | null): User {
    return data ? new User(data) : User.None
  }

  constructor(private data: CoreUser) {}

  private getAttr<T extends keyof CoreUser>(attr: T): CoreUser[T] {
    return this.data[attr]
  }

  get coreUser() {
    return this.data
  }

  get id() {
    return this.getAttr('id')
  }

  get isNone() {
    return this === User.None
  }

  get isAnonymous() {
    return this.isNone ? true : this.getAttr('anonymous')
  }

  get isPremium() {
    return this.getAttr('type') === 'Premium' ? true : false
  }

  get isTest() {
    return this.getAttr('isTest')
  }

  get email() {
    return this.getAttr('email')
  }

  get groups() {
    return this.getAttr('groups') || []
  }

  get type() {
    return this.getAttr('type')
  }

  get institutionId() {
    return this.getAttr('institutionId')
  }

  get name() {
    return this.getAttr('name')
  }

  get customFields() {
    return this.getAttr('customFields')
  }

  private getCustomField(key: AuthCustomFieldsKey) {
    return deserializeValue(this.customFields?.[serializeKey(key)])
  }

  get customFieldRole() {
    return this.getCustomField(AuthCustomFieldsKey.role) as string | undefined
  }

  get teamType() {
    return this.getCustomField(AuthCustomFieldsKey.teamType) as string | undefined
  }

  get industryType() {
    return this.getCustomField(AuthCustomFieldsKey.industryType) as string | undefined
  }

  get companySize() {
    return this.getCustomField(AuthCustomFieldsKey.companySize) as string | undefined
  }

  get graduationYear() {
    return this.getCustomField(AuthCustomFieldsKey.graduationYear) as string | undefined
  }

  get registrationDate() {
    return this.getAttr('registrationDate')
  }
}
